<template>
  <div
    v-if="invoice"
    class="wire-transfer-container"
  >
    <p>
      To complete payment, send the total amount via an electronic transfer with
      the following information.
    </p>

    <div id="amount">Amount {{ customAmount }}</div>

    <div class="wire-transfer-inner">
      <label>Payee:</label>
      <span>Leland Little Auctions</span>

      <label>Bank Information</label>
      <span>Truist Bank</span>

      <label>Account Number</label>
      <span>1340004390562</span>

      <label>ABA Routing Number:</label>
      <span>053101121</span>

      <label>Swift Number:</label>
      <span>BRBTUS33</span>

      <label>Include Text:</label>
      <span>
        {{ invoice.customer_display_name }} - Invoice #{{ invoice.invoice_id }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WireTransferComponent',
  props: ['invoice'],
  data() {
    return {
      customAmount: 0,
    }
  },
  created() {
    if(this.invoice !== undefined){
      this.customAmount = this.invoice.invoice_balance ? this.invoice.invoice_balance.toFixed(2) : 0
    }
  },
}
</script>
<style scoped>
#amount {
  font-weight: bold;
  text-align: center;
  font-size: 18px;
}
</style>